<template>
  <div>
    <div style="padding-left:0px;padding-right:0px;" class="modules-content">
      <div class="module-item">
        <div class="title-content" style="grid-gap:0;">
          <h3 class="module-title">Cupons do produto</h3>
          <p></p>
          <p></p>
          <a v-if="addNew==false" v-on:click="addNew=true" class="form-control btn btn-default-lms">
            Adicionar
            <i class="fa fa-plus"></i>
          </a>
          <a
            v-else
            v-on:click="newClass = {};addNew=false;"
            class="form-control btn btn-default-lms"
          >
            Cancelar
            <i class="fa fa-times-circle"></i>
          </a>

          <div>
            <span class="module-progress loading-placeholder"></span>
          </div>
        </div>

        <li class="lesson-subtitle li-custom">
          <span class="lesson-title">Contagem</span>
          <span class="lesson-title">Código</span>
          <span class="lesson-description">Valor</span>
          <span class="lesson-description">Início da validade</span>
          <span class="lesson-description">Fim da validade</span>
          <span class="lesson-description">Padrão</span>
          <span class="lesson-option"></span>
        </li>

        <ul class="lessons-list">
          <li v-if="addNew" class="lesson li-custom">
            <div class="lesson-title"></div>
            <div class="lesson-title control-group">
              <div class="controls">
                <input id="code" type="text" v-model="newCoupon.code" class="form-control" />
              </div>
            </div>

            <div class="control-group">
              <div class="controls">
                <div class="input-group">
                  <input type="number" v-model="newCoupon.value" class="form-control" />
                  <a
                    @click="percentage = true"
                    v-bind:class="{ active: percentage==true }"
                    class="input-group-addon btn btn-success"
                  >
                    <i class="fa fa-percent" aria-hidden="true"></i>
                  </a>
                  <a
                    @click="percentage = false"
                    v-bind:class="{ active: percentage==false }"
                    class="input-group-addon btn btn-success"
                  >
                    <i class="fa fa-usd" aria-hidden="true"></i>
                  </a>
                </div>
              </div>

              <!-- <input style="width:100%;" type="text" v-model="quiz.minimumScore" /> -->
            </div>

            <div class="lesson-title control-group">
              <div class="controls">
                <date-input class="form-control" v-model="newCoupon.validityStart"></date-input>
              </div>
            </div>

            <div class="lesson-title control-group">
              <div class="controls">
                <date-input class="form-control" v-model="newCoupon.validityEnd"></date-input>
              </div>
            </div>

            <!-- <div class="lesson-description control-group">
              <div class="controls">
                <input id="limit" type="number" v-model="newClass.limit" class="form-control" />
              </div>
            </div>-->

            <span class="lesson-option">
              <a
                :disabled="couponsLoading"
                :class="{ 'disabled': $v.newCoupon.$error }"
                v-on:click="addCoupon()"
                href="#"
              >Adicionar</a>
            </span>
          </li>

          <li
            v-show="!couponsLoading"
            v-for="c in productCoupons"
            :key="c.id"
            class="lesson li-custom"
          >
            <span class="lesson-title">{{c.count}}</span>
            <span class="lesson-title">{{c.code}}</span>
            <span v-if="c.value" class="lesson-title">R${{c.value}}</span>
            <span v-else class="lesson-title">{{c.percentage}}%</span>
            <span class="lesson-title">{{c.validityStart | formatDate}}</span>
            <span class="lesson-title">{{c.validityEnd | formatDate}}</span>
            <toggle-button
              :disabled="loadingCoupon"
              @change="toggle(c)"
              :value="c.active"
              :color="{checked: '#28a745', unchecked: '#dc3545'}"
              :width="70"
              :sync="true"
              :labels="{checked: 'Padrão', unchecked: ''}"
            />
            <span class="lesson-option">
              <a v-on:click="removeCoupon(c.id)" href="#">Remover</a>
            </span>
          </li>

          <li v-show="couponsLoading" style="margin-left:auto;margin-right:auto;">
            <loading :color="'#1abdde'" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped>
.li-custom {
  grid-template-columns: 0.75fr 0.75fr 0.75fr 1fr 1fr 0.75fr 0.75fr !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
.has-error {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
</style>


<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

axios.defaults.withCredentials = true;

export default {
  props: ["product", "productCoupons", "couponsLoading"],
  data() {
    return {
      percentage: true,
      unlimited: false,
      newCoupon: {},
      addNew: false,
      modules: [],
      loadingCoupon: false
    };
  },
  validations: {
    newCoupon: {
      code: { required },
      value: { required },
      validityStart: { required },
      validityEnd: { required }
    }
  },
  methods: {
    toggle(coupon) {
      this.loadingCoupon = true;
      if (coupon.percentage) {
        coupon.value = undefined;
      } else {
        coupon.percentage = undefined;
      }

      coupon.active = !coupon.active;
      const path = this.$global.endpoint + "/product/admin/coupon/save";
      axios
        .post(path, { coupon: coupon })
        .then(res => {
          this.newCoupon = {};
          this.loadingCoupon = false;
          this.$emit("update");
        })
        .catch(error => {
          this.loadingCoupon = false;
          console.error(error);
        });
    },
    changeUnlimited(value) {
      console.log(value);
    },
    addCoupon() {
      this.couponsLoading = true;
      this.$v.newCoupon.$touch();
      if (this.$v.newCoupon.$error) {
        console.log("erro");
        return;
      }

      if (this.percentage) {
        this.newCoupon.percentage = this.newCoupon.value;
        this.newCoupon.value = undefined;
      }

      this.newCoupon.productId = this.product.id;
      const path = this.$global.endpoint + "/product/admin/coupon/save";
      axios
        .post(path, { coupon: this.newCoupon })
        .then(res => {
          this.newCoupon = {};
          this.$emit("update");
        })
        .catch(error => {
          console.error(error);
        });
    },
    removeCoupon(couponId) {
      this.couponsLoading = true;
      const path = this.$global.endpoint + "/product/admin/coupon/remove";
      axios
        .post(path, {
          id: couponId
        })
        .then(res => {
          this.$emit("update");
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {}
};
</script>
